<template>
  <button
    type="button"
    :class="{'disabled':disabled}"
    @click="onClick"
  >

    <transition name="vBtn-label" mode="out-in">
      <div v-if="loading">
        <span class="spinner"></span>
      </div>
      <svg v-else-if="success" width="26" height="24" viewBox="0 0 36 36">
        <path fill="#fff" d="M13.5 24.26L7.24 18l-2.12 2.12 8.38 8.38 18-18-2.12-2.12z" />
      </svg>
      <span v-else>
        <slot></slot>
      </span>
    </transition>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
</script>

<style  scoped>
.spinner {
  display: inline-block;
  margin: 0 8px;
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  border: 0.215em solid transparent;
  vertical-align: middle;
  font-size: 16px;
  border-top-color: white;
  -webkit-animation: spin 1s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;
  animation: spin 1s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;
}

.button__loader svg {
  -webkit-filter: drop-shadow(2px 3px 6px rgba(0, 0, 0, 0.4));
  filter: drop-shadow(2px 3px 6px rgba(0, 0, 0, 0.4));
}

.vBtn-label-enter-active {
  -webkit-animation: slide-in-down 100ms cubic-bezier(0, 0, 0.2, 1);
  animation: slide-in-down 100ms cubic-bezier(0, 0, 0.2, 1);
}

.vBtn-label-leave-active {
  -webkit-animation: slide-out-down 100ms cubic-bezier(0.4, 0, 1, 1);
  animation: slide-out-down 100ms cubic-bezier(0.4, 0, 1, 1);
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes slide-in-down {
  0% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slide-in-down {
  0% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@-webkit-keyframes slide-out-down {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
  40% {
    opacity: 0.2;
  }
  100% {
    -webkit-transform: translateY(20px);
    transform: translateY(20px);
    opacity: 0;
  }
}
@keyframes slide-out-down {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
  40% {
    opacity: 0.2;
  }
  100% {
    -webkit-transform: translateY(20px);
    transform: translateY(20px);
    opacity: 0;
  }
}
</style>